import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { environment } from '../../../../environments/environment';
import { AuthService } from '../../../services/auth/auth.service';

@Component({
    selector: 'app-change-pass',
    templateUrl: './change-pass.component.html',
    styleUrls: ['./change-pass.component.css']
})
export class ChangePassComponent implements OnInit {
    /**
     * Acá se declaran las variables a utilizar en el resto de las funciones del componente, importante énfasis en las siguientes:
     *
     * code: Código del mensaje de respuesta a mostrar en la función.
     * titulo: Título a enviar; solo si se recibe con la respuesta del endpoint.
     * detalle: Detalle a enviar; solo si se recibe con la respuesta del endpoint.
     */
    credentialsForm: FormGroup;
    visibleSpinner = false;
    showMsg = false;
    regExpCorreo: string = environment.regExpCorreo;
    minLengthPass: number = environment.minLengthPass;
    nombreSistema: string = environment.nombreSistema;

    // Variables para mensaje
    code: any;
    titulo: any;
    detalle: any;

    temp_code_register: string;
    temp_mail_register: string;


    constructor(private formBuilder: FormBuilder,
        private router: Router,
        private authService: AuthService) {
    }

    ngOnInit(): void {

        this.temp_mail_register = sessionStorage.getItem('temp_mail_register') ? sessionStorage.getItem('temp_mail_register') : '';
        this.temp_code_register = sessionStorage.getItem('temp_code_register') ? sessionStorage.getItem('temp_code_register') : '';

        this.credentialsForm = this.formBuilder.group({
            correo: [{
                value: this.temp_mail_register,
                disabled: (this.temp_mail_register !== "") ? true : false
            }, [Validators.required, Validators.pattern(this.regExpCorreo)]],
            passActual: [{
                value: this.temp_code_register,
                disabled: (this.temp_code_register !== "") ? true : false
            }, [Validators.required, Validators.minLength(this.minLengthPass)]],
            pass: ['', [Validators.required, Validators.minLength(this.minLengthPass)]],
            passConfirmacion: ['', [Validators.required, Validators.minLength(this.minLengthPass)]]
        });

        document.getElementById('correo').focus();
    }

    cambiarPass() {
        this.visibleSpinner = true;
        // console.log(this.credentialsForm.value);

        const passActual = (this.temp_code_register !== "") ? this.temp_code_register : this.credentialsForm.value.passActual;
        const pass = this.credentialsForm.value.pass;
        const passConfirmacion = this.credentialsForm.value.passConfirmacion;
        const usuario = (this.temp_mail_register !== "") ? this.temp_mail_register : this.credentialsForm.value.correo;

        if (passActual === pass) {
            this.visibleSpinner = false;
            this.code = 'change_pass.warn.11';
        } else if (pass !== passConfirmacion) {
            this.visibleSpinner = false;
            this.code = 'change_pass.warn.12';
        } else {
            this.authService.cambiarPass(usuario, passActual, pass, passConfirmacion)
                .subscribe((res: any) => {
                    this.visibleSpinner = false;

                    if (res.success) {
                        this.code = 'change_pass.success.default';
                        sessionStorage.clear();
                        setTimeout(() => {
                            //this.router.navigate(['auth/login']);
                            this.iniciarSesion(usuario, pass);
                        }, 1000);
                    } else {
                        let errores = '';

                        if (res.data.message === 'Ver errores en extras') {
                            if (res.data.extra.length > 1) {
                                errores += '<ul>';
                                errores += '<li>' + res.data.extra.join('</li><li>') + '</li>';
                                errores += '</ul>';
                            } else {
                                errores = res.data.extra[0];
                            }
                        } else {
                            errores = res.data.message;
                        }
                        this.code = 'change_pass.warn.13';
                        this.detalle = errores;
                    }
                }, error => {
                    console.log('Error ', error);
                    this.visibleSpinner = false;
                    this.code = 'change_pass.error.default';
                    this.detalle = error;
                });
        }
    }

    iniciarSesion(correo, pass): void {
        localStorage.clear();
        this.visibleSpinner = true;
        this.code = '';
        this.detalle = '';

        this.authService.iniciarSesion(correo, pass)
            .subscribe((res: any) => {
                this.visibleSpinner = false;

                if (res.success) {
                    if (res.data.code === 0) {
                        // Se almacena el usuario y token en localStorage
                        localStorage.setItem('un', this.credentialsForm.value.correo);
                        localStorage.setItem('at', res.data.access_token);

                        // Se almacena el usuario y token en service
                        this.authService.setUsuario(this.credentialsForm.value.correo);
                        this.authService.setToken(res.data.access_token);

                        this.authService.obtenerInformacionUsuario()
                            .subscribe((resu: any) => {
                                if (resu.success && resu.status_code === 200) {
                                    this.code = 'login.success.default';
                                    localStorage.setItem('nc', resu.data.usuario.nombre + ' ' + resu.data.usuario.apellido);
                                    this.authService.setLoggedIn(true);
                                    setTimeout(() => {
                                        this.router.navigate(['inicio']);
                                    }, 1000);
                                } else {
                                    this.code = 'login.warn.13';
                                }

                            }, error => {
                                this.code = 'login.warn.14';
                                this.detalle = error;
                            });
                    }
                } else {
                    let errores = '';
                    this.visibleSpinner = false;

                    if (res.data.message === 'Ver errores en extras') {
                        if (res.data.extra.length > 1) {
                            errores += '<ul>';
                            errores += '<li>' + res.data.extra.join('</li><li>') + '</li>';
                            errores += '</ul>';
                        } else {
                            errores = res.data.extra[0];
                        }
                    } else {
                        errores = res.data.message;
                    }
                    this.code = 'login.warn.15';
                    this.detalle = errores;
                }
            }, error => {
                this.visibleSpinner = false;
                this.code = 'login.error.default';
                this.detalle = error;
            });
    }
}
